<app-template-article 
    [title]="article.title"
    [date]="article.date"
    [content]="article.content"
    [pathImg]="article.pathImg">
</app-template-article>
